<template>
  <div class="record-picker-tabs" role="tablist" :aria-label="ariaLabel">
    <button
      type="button"
      class="record-picker-tab"
      :class="{active: value === 'registered'}"
      role="tab"
      :aria-selected="value === 'registered' ? 'true' : 'false'"
      @click="$emit('input', 'registered')"
    >
      Evidované
      <span class="record-count">{{ registeredCount }}</span>
    </button>
    <button
      type="button"
      class="record-picker-tab add-new"
      :class="{active: value === 'new'}"
      role="tab"
      :aria-selected="value === 'new' ? 'true' : 'false'"
      @click="$emit('input', 'new')"
    >
      <span class="add-icon" aria-hidden="true">+</span>
      Pridať nový
    </button>
  </div>
</template>

<script>
export default {
  name: "RecordPickerTabs",
  props: {
    value: {
      type: String,
      default: "registered",
    },
    registeredCount: {
      type: Number,
      default: 0,
    },
    ariaLabel: {
      type: String,
      default: "Výber sekcie",
    },
  },
};
</script>

<style scoped lang="scss">
.record-picker-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  width: 100%;
  margin: 4px 0 24px;
  padding: 6px;
  border: 1px solid var(--app-border);
  border-radius: 14px;
  background: var(--app-surface-muted);
}

.record-picker-tab {
  display: inline-flex;
  min-width: 0;
  min-height: 48px;
  padding: 10px 12px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  color: var(--app-text-muted);
  font-weight: 800;
  cursor: pointer;
}

.record-picker-tab:focus-visible {
  outline: 2px solid var(--app-primary);
  outline-offset: 2px;
}

.record-picker-tab.active {
  border-color: var(--app-border);
  background: var(--app-surface);
  color: var(--app-text);
  box-shadow: var(--app-shadow);
}

.record-picker-tab.add-new {
  color: var(--app-primary);
}

.record-picker-tab.add-new.active {
  border-color: color-mix(in srgb, var(--app-primary) 48%, var(--app-border));
  background: color-mix(in srgb, var(--app-primary) 10%, var(--app-surface));
}

.record-count,
.add-icon {
  display: inline-flex;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: color-mix(in srgb, var(--app-primary) 12%, transparent);
  color: var(--app-primary);
  font-size: 12px;
  font-weight: 900;
}

.add-icon {
  width: 22px;
  padding: 0;
  background: var(--app-primary);
  color: #fff;
  font-size: 18px;
  line-height: 1;
}

@media (max-width: 480px) {
  .record-picker-tab {
    padding-inline: 8px;
    font-size: 13px;
  }
}
</style>
